import React from 'react';

// State
import {
  selectCompletedTasks,
  unCompleteTask
} from 'src/react/recommendations/store/slices/tasks';
import { useDispatch, useSelector } from 'react-redux';

// Components
import Expander from 'src/react/recommendations/components/expander';
import CompletedTask from 'src/react/recommendations/components/Task/CompletedTask';
import logger from 'src/analytics/logger';

const CompletedTasks = () => {
  const completedTasks = useSelector(selectCompletedTasks);
  const dispatch = useDispatch();

  const makeIncomplete = async (task) => {
    logger.trackElementClicked({
      elementId: 'Mark Task Incomplete',
      label: 'Mark Incomplete',
      recommendation_id: `RPLUS_${task.recommendation_id}`
    });

    await dispatch(unCompleteTask(task));
  };

  const trackExpandedState = () => {
    logger.trackElementClicked({
      elementId: 'Completed Task Toggle',
      label: 'Completed'
    });
  };

  return (
    <Expander tasks={completedTasks} onChange={trackExpandedState}>
      {completedTasks.map((task, index) => (
        <CompletedTask
          task={task}
          key={`${task.id}${index}`}
          onCompleteClick={makeIncomplete}
        />
      ))}
    </Expander>
  );
};

export default CompletedTasks;
